import React from "react";
import {
    View,
    Text,
    StyleSheet,
    Svg,
    Path,
    G,
    Circle,
} from "@react-pdf/renderer";

const styles = StyleSheet.create({
    container: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
    },
    icon: {
        marginRight: "3px"
    },
    text: {
        fontSize: "8px",
        color: "#ed1f24",
        fontWeight: "bold",
    }
});

const Icon = () => (
    <Svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 40 40">
  <G id="Failed_Vote_Icon" transform="translate(-120.477 -97.275)">
    <Circle id="Ellipse_717-7" data-name="Ellipse 717-7" cx="20" cy="20" r="20" transform="translate(120.476 97.275)" fill="#ed1f24"/>
    <G id="Group_5484" data-name="Group 5484" transform="translate(129.666 108.769)">
      <G id="np_like_888708_000000" transform="translate(1.811 0.505)">
        <Path id="Path_28126" data-name="Path 28126" d="M37.5,24.824a1.392,1.392,0,0,0,1.406,1.406h4.219c.225,0,1.013.338.393,1.294a12.992,12.992,0,0,0-.393,3.488,1.406,1.406,0,0,0,2.813,0,5.781,5.781,0,0,1,3.937-5.344V18.356c-1.8-.619-2.25-1.688-4.5-1.688H41.156a1.406,1.406,0,0,0-1.124,2.25,1.392,1.392,0,0,0-1.406,1.406,1.531,1.531,0,0,0,.338.957,1.387,1.387,0,0,0-.9,1.294,1.531,1.531,0,0,0,.338.957,1.355,1.355,0,0,0-.9,1.293Z" transform="translate(-37.5 -16.668)" fill="#fff"/>
        <Path id="Path_28127" data-name="Path 28127" d="M18.357,47.063h2.812V37.5H18.356a1.692,1.692,0,0,0-1.688,1.688v6.188a1.657,1.657,0,0,0,1.688,1.688Z" transform="translate(-3.169 -36.938)" fill="#fff"/>
      </G>
    </G>
  </G>
</Svg>

)

const FailingIcon = () => (
    <View style={styles.container}>
        <View style={styles.icon}>
            <Icon />
        </View>
        <Text style={styles.text}>Failing</Text>
    </View>
);

export default FailingIcon;
